(function ($) {
    Drupal.behaviors.OR33 = {
        attach() {
            $(once('OR33', 'body')).first().each(function () {
                const $accordionButtons = $('.OR33__accordion-trigger');

                $accordionButtons.on("click", function () {
                    let $accordion = $(this).closest('.OR33');
                    let $accordionContent = $("#"+ $(this).attr('aria-controls'), $accordion);
                    let hiddenAttr = $accordionContent.attr('hidden');

                    $accordionContent.slideToggle();
                    if (typeof hiddenAttr == typeof undefined) {
                        $accordionContent.attr('hidden', "");
                        $(this).attr('aria-expanded', 'false');
                    } else {
                        $accordionContent.removeAttr('hidden');
                        $(this).attr('aria-expanded', 'true');
                    }
                });

            })
        }
    };
}(jQuery));
